// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"Filters__modalContainer___7Vj3G","modalBody":"Filters__modalBody___2o3g1","title":"Filters__title___3KUs5","subtitle":"Filters__subtitle___3c7NS","dividerDouble":"Filters__dividerDouble___Egksn","CTAContainer":"Filters__CTAContainer____0qHc","filtersContainer":"Filters__filtersContainer___1wVWC"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/companies/components/Filters.scss
// module id = 1678
// module chunks = 0